import './bsu_style.css';
import {  Row, Col, Container, Form } from "react-bootstrap";
import LevelList from './components/LevelList'
import StudyTypeList from './components/StudyTypeList'
import FacultyList from './components/FacultyList'
import SubmitForm from './components/SubmitForm'

function App() {
  return (
    <div>
      <form name='regis_form' id='regis_form'>
      <Container className="square border rounded banner">
        <Row>
          <Col md={12}>
            <img src="./images/regis_topbar.jpg" className='logo' alt='logo' ></img>
          </Col>
        </Row>
      </Container>
      <Container className="square border rounded content">
        <Row>
          <Col md={6}>
            <Form.Label htmlFor='study_level'>ระดับการศึกษาที่ต้องการสมัคร: <span className="required">*</span></Form.Label>
            <LevelList id="study_level"></LevelList>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Form.Label htmlFor='faculty'>คณะที่ต้องการสมัคร: <span className="required">*</span></Form.Label>            
            <FacultyList id="faculty"></FacultyList>
          </Col>
          <Col md={6}>
            <Form.Label htmlFor='department'>สาขาที่ต้องการสมัคร: <span className="required">*</span></Form.Label>
            <div id="div_department"></div>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Form.Label htmlFor='department'>ภาคที่ต้องการสมัคร: <span className="required">*</span></Form.Label>
            <StudyTypeList id="study_type"></StudyTypeList>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Form.Label htmlFor='department'>คำนำหน้าชื่อ: <span className="required">*</span></Form.Label><br />
            <Form.Check inline label="นาย" value="นาย" name="title" type='radio' id='title01' />
            <Form.Check inline label="นาง" value="นาง" name="title" type='radio' id='title02' />
            <Form.Check inline label="นางสาว" value="นางสาว" name="title" type='radio' id='title03' />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Form.Label htmlFor='firstname'>ชื่อ: <span className="required">*</span></Form.Label>
            <Form.Control type="text" id="firstname"></Form.Control>
          </Col>
          <Col md={6}>
            <Form.Label htmlFor='lastname'>นามสกุล: <span className="required">*</span></Form.Label>
            <Form.Control type="text" id="lastname"></Form.Control>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Form.Label htmlFor='education'>สถานศึกษา(ที่จบล่าสุด): <span className="required">*</span></Form.Label>
            <Form.Control type="text" id="education"></Form.Control>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Form.Label htmlFor='group1'>จบการศึกษา(เทียบเท่าวุฒิการศึกษา): <span className="required">*</span></Form.Label>
          </Col>
          <Col md={4}>
            <Form.Check inline label="ม.6" value="ม.6" name="grad" type='radio' id='edu01' />
          </Col>
          <Col md={4}>
            <Form.Check inline label="สอบเทียบ (กศน)" value="สอบเทียบ (กศน)" name="grad" type='radio' id='edu02' />
          </Col>
          <Col md={4}>
            <Form.Check inline label="ปวช." value="ปวช." name="grad" type='radio' id='edu04'/>
          </Col>
          <Col md={4}>
            <Form.Check inline label="ปวส." value="ปวส." name="grad" type='radio' id='edu05'/>
          </Col>
          <Col md={4}>
            <Form.Check inline label="ปริญญาตรี" value="ปริญญาตรี" name="grad" type='radio' id='edu06'/>
          </Col>
          <Col md={4}>
            <Form.Check inline label="ปริญญาโท" value="ปริญญาโท" name="grad" type='radio' id='edu07'/>
          </Col>
        </Row>
        <Row>
        <Col md={4}>
            <Form.Label htmlFor='telephone'>เบอร์ติดต่อ: <span className="required">*</span></Form.Label>
            <Form.Control type="text" id="telephone"></Form.Control>
          </Col>          
          <Col md={4}>
            <Form.Label htmlFor='idline'>ID Line:</Form.Label>
            <Form.Control type="text" id="idline"></Form.Control>
          </Col>
          <Col md={4}>
            <Form.Label htmlFor='email'>อีเมล์:</Form.Label>
            <Form.Control type="text" id="email"></Form.Control>
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <Form.Label htmlFor='address'>ที่อยู่:</Form.Label>
            <Form.Control type="text" id="address"></Form.Control>
          </Col>
          <Col md={4}>
            <Form.Label htmlFor='district'>แขวง/ตำบล:</Form.Label>
            <Form.Control type="text" id="district"></Form.Control>
          </Col>
          <Col md={4}>
            <Form.Label htmlFor='khet'>เขต/อำเภอ:</Form.Label>
            <Form.Control type="text" id="khet"></Form.Control>
          </Col>
          <Col md={4}>
            <Form.Label htmlFor='province'>จังหวัด:</Form.Label>
            <Form.Control type="text" id="province"></Form.Control>
          </Col>
          <Col md={4}>
            <Form.Label htmlFor='postcode'>รหัสไปรษณีย์:</Form.Label>
            <Form.Control type="text" id="postcode"></Form.Control>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Form.Label htmlFor='borrow'>ประสงค์จะกู้ยืม กยศ./กรอ.:</Form.Label>
            <Form.Select id="borrow">
              <option value="ทุนส่วนตัว">ทุนส่วนตัว</option>
              <option value="ประสงค์กู้ยืม กยศ./กรอ.">ประสงค์กู้ยืม กยศ./กรอ.</option>
              <option value="เป็นผู้กู้ กยศ./กรอ. รายเก่า">เป็นผู้กู้ กยศ./กรอ. รายเก่า</option>
            </Form.Select>
          </Col>
        </Row>
        <Row>
          <Col md={12}><Form.Label htmlFor=''>&nbsp;</Form.Label></Col>
        </Row>
        <Row>
          <Col md={12}><Form.Label htmlFor=''>หากมีโอกาสจะแนะนำเพื่อนมาเรียน (เพื่อรับทุนการศึกษา)</Form.Label></Col>
        </Row>
        <Row>
          <Col md={6}>
            <Form.Label htmlFor='friend'>ขื่อ-นามสกุล (เพื่อน):</Form.Label>
            <Form.Control type="text" id="friend"></Form.Control>
          </Col>
          <Col md={6}>
            <Form.Label htmlFor='friend_telephone'>เบอร์โทรศัพท์ (เพื่อน):</Form.Label>
            <Form.Control type="text" id="friend_telephone"></Form.Control>
          </Col>
        </Row>
        <Row>
          <Col md={12} style={{textAlign: 'center', marginTop: '10px'}}>
            <Form.Label htmlFor='submit_form'>(เพื่อรักษาสิทธิ์ของท่าน โปรดกรอกข้อมูลให้ครบ ในการรับทุนการศึกษา)</Form.Label>
          </Col>
        </Row>
        <Row>
          <Col md={12} style={{textAlign: 'center', marginTop: '10px'}}>
            <SubmitForm id="submit_form"></SubmitForm>
          </Col>
        </Row>
      </Container>
      <span>&nbsp;</span>
      </form>
    </div>
  );
}

export default App;